import React from "react";
import { useTranslation } from "react-i18next";
import Button from "../../UiComponents/Button";
import styles from "./InfosUser.module.scss";
import { RiAdminFill, RiUserAddFill, SiAirplayaudio } from "react-icons/si";

const InfosCabine = ({
  ownerName,
  email,
  login,
  date,
  inviteOwnerId,
  setOwnerId,
  setdisplayInfosOwnerLinkCab,
  setDisplayConnectingUserWithCabineSearch,
}) => {
  const { t } = useTranslation();
  return (
    <div className={styles.containerInfosUser}>
      <div className={styles.containerInviteInfos}>
        <div className={styles.invite}>
          <div className={styles.title}>
            <SiAirplayaudio />
            <h3>{t("superadmin_ui.cabine_owner_info")}</h3>
          </div>

          <div className={styles.infos}>
            <div>
              <span>{t("superadmin_ui.name_label")}</span> {ownerName}
            </div>
            <div>
              <span>Email:</span> {email}
            </div>
            <div>
              <span>Login:</span> {login}
            </div>
            <div>
              <span>{t("superadmin_ui.client_since")}</span> {date}
            </div>
          </div>
          <Button
            onPress={() => {
              setOwnerId(inviteOwnerId);
              setdisplayInfosOwnerLinkCab(false);
              setDisplayConnectingUserWithCabineSearch(true);
            }}
            styles={"btnValidation"}
            text={t("superadmin_ui.connect_as")}
          />
        </div>
      </div>
    </div>
  );
};

export default InfosCabine;
